import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";
import SnackbarContext from "../contexts/SnackbarContext";

export default function useDownloadFetch() {
    const auth = useContext(AuthContext)
    const snackbar = useContext(SnackbarContext);
    async function download(urlPath: string, fileName: string, method = "POST", payload?: any) {
        try {
            const token = await auth.getToken();
            const response = await fetch(urlPath, {
                method: method,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: payload ? JSON.stringify(payload) : undefined,
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            snackbar.showMessage("Sikeres letöltés", "success");
            return true;
        } catch (error) {
            snackbar.showMessage("Hiba történt a letöltés során.", "error");
            return false;
        }
    }

    return {
        download
    }
}